import { KeyValuePair } from '@app/core/models/keyValuePair';

class Actives {
  No = { key: false, value: 'Nee' };
  Yes = { key: true, value: 'Ja' };
}
const actives = new Actives();
const keyValuePairs: Array<KeyValuePair> = [
  actives.No,
  actives.Yes
];

export {
    actives,
    keyValuePairs
};
